import React, { useEffect, useState } from "react";

//Import Breadcrumb
import { Checkbox, FormControl, FormControlLabel, FormGroup, FormHelperText, FormLabel, Grid, Button } from "@mui/material";
import { Icon } from "@iconify/react/dist/iconify.js";

const CheckBoxGroup = ({ title, data, ml, row, onChange, values, disabled, error, sm = 6, xs = 12, isOptional }) => {
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const [showAll, setShowAll] = useState(false);

    const handleChange = (e, item) => {
        let prev = values || [];
        const value = item?.value;
        const allValues = data?.filter(x => x.value !== -1).map(x => x.value); // Get all values excluding "Select All"

        // If "Select All" is checked
        if (value === -1 && e.target.checked === true) {
            onChange && onChange(allValues, item, e.target.checked);
        }
        // If "Select All" is unchecked
        else if (value === -1 && e.target.checked === false) {
            onChange && onChange([], item, e.target.checked);
        }
        // Toggle individual value
        else {
            let newValues;
            if (prev.includes(value)) {
                newValues = prev.filter(v => v !== value);
            } else {
                newValues = [...prev, value];
            }
            onChange && onChange(newValues, item, e.target.checked);
        }
    }

    return (
        <React.Fragment>
            <FormControl variant="outlined" fullWidth>
                <Grid container>
                    {title && <FormLabel style={{ fontFamily: 'FunnelSans', fontWeight: 500, fontSize: 14, margin: 0, color: "#1D1B1B", justifyContent: "space-between", display: "flex" }}>{title} {isOptional ? <span className="optional-label">Optional</span> : null}</FormLabel>}
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <FormGroup row={row} sx={{ display: "flex", marginLeft: ml || 0 }}>
                                {
                                    data && data.length > 0 && (showAll ? data : data.slice(0, 7)).map((x, idx) =>
                                        <Grid
                                            item
                                            xs={xs}
                                            sm={sm}
                                            key={`radio-group-${idx}`}
                                            onMouseEnter={() => setHoveredIndex(idx)}
                                            onMouseLeave={() => setHoveredIndex(null)}
                                            sx={{
                                                backgroundColor: hoveredIndex === idx ? "#F5F5F5" : "transparent",
                                                transition: "background-color 0.3s ease",
                                                paddingLeft: "10px",
                                                paddingRight: "10px",
                                                borderRadius: "10px"
                                            }}
                                        >
                                            <FormControlLabel key={idx}
                                                sx={{ marginBottom: "0px" }}
                                                control={
                                                    <Checkbox
                                                        checked={
                                                            x.value === -1
                                                                ? data && data.length > 0 && data.filter(d => d.value !== -1).every(d => values?.includes(d.value))
                                                                : values?.includes(x.value)
                                                        }
                                                        disabled={disabled}
                                                        key={idx}
                                                        error={error ? true : false}
                                                        sx={{
                                                            '&.Mui-checked': {
                                                                color: "#1D1B1B",
                                                            },
                                                            '& .MuiSvgIcon-root': {
                                                                fontSize: 20,
                                                                borderColor: "#E2E2E2",
                                                                borderRadius: "18px",
                                                            },
                                                            color: '#1D1B1B'
                                                        }}
                                                        onChange={(e) => disabled ? "" : onChange && handleChange(e, x)}
                                                        value={x.name} />
                                                }
                                                label={<span style={{ fontFamily: 'FunnelSans', fontSize: 14, fontWeight: x?.label === "Select All" ? 500 : "inherit" }}>{x.label}</span>}
                                            />
                                        </Grid>

                                    )
                                }
                            </FormGroup>
                        </Grid>
                        <Grid item xs={12} ml={1}>
                            {
                                data && data.length > 7 && (
                                    showAll ? (
                                        <span onClick={() => setShowAll(false)} style={{ marginTop: "10px" }}>
                                           <span className="clickable-link" style={{textUnderlineOffset: 2}}>Show less</span>  <i className="ri-arrow-up-s-line" />
                                        </span>
                                    ) : (
                                        <span onClick={() => setShowAll(true)} style={{ marginTop: "10px" }}>
                                            <span className="clickable-link" style={{textUnderlineOffset: 3}}>Show All</span>  <i className="ri-arrow-down-s-line" />
                                        </span>
                                    )
                                )
                            }
                        </Grid>
                    </Grid>

                </Grid>
            </FormControl>

        </React.Fragment >
    );
};

export default CheckBoxGroup;
